import React from "react"
import { generatePath, Link, useNavigate } from "react-router-dom"
import { useLocalObservable } from "mobx-react"
import { observer } from "mobx-react-lite"
import { Button, Flex, Typography } from "antd"
import Table, { ColumnsType } from "antd/es/table"
import { PlusCircleOutlined } from "@ant-design/icons"

import editIcon from "@src/app/assets/icons/edit.svg"
import trashIcon from "@src/app/assets/icons/trash-red.svg"
import { CreateButton } from "@src/app/components/CreateButton"
import { NoContent } from "@src/app/components/NoContent/Index"
import { IdItem } from "@src/app/components/tableRowItems/idItem"
import { DefaultPageLayout } from "@src/app/layouts/DefaultPageLayout"
import { paths } from "@src/app/paths"
import { WidgetsCollection } from "@src/pages/widgets/classes/WidgetsCollection"
import { WidgetResponse } from "@src/shared/api/generated"
import { dateTimeFormat } from "@src/shared/date"
import css from "./index.module.css"

const { Paragraph, Title } = Typography

export const WidgetsPage = observer(() => {
  const widgets = useLocalObservable(() => new WidgetsCollection())

  const navigate = useNavigate()

  const columns: ColumnsType<WidgetResponse> = [
    {
      align: "center",
      dataIndex: "id",
      render: (_, { id }) => (
        <Flex justify="center">
          <IdItem id={id} />
        </Flex>
      ),
      title: "ID",
    },
    {
      align: "center",
      dataIndex: "name",
      render: (_, { id, name }) => (
        <Link
          id="GENERATED_ID_WIDGETS_LINK_VOID_1"
          to={generatePath(paths.widgetModify, { id })}
        >
          {name}
        </Link>
      ),
      title: "Name",
    },
    {
      align: "center",
      className: css.truncate,
      dataIndex: "url",
      render: (_, { url }) => <span className={css.truncate}>{url}</span>,
      title: "Domain URL",
    },
    {
      align: "center",
      dataIndex: "created_at",
      render: (_, { created_at }) => dateTimeFormat(created_at),
      title: "Date",
    },
    {
      align: "center",
      render: (_, { id }) => (
        <Flex justify="center">
          <Button
            icon={<img alt="edit" src={editIcon} />}
            onClick={() =>
              navigate({
                pathname: generatePath(paths.widgetModify, { id }),
                search: "?editImmediately=true",
              })
            }
            title="Edit Widget"
            type="text"
          />
          <Button
            icon={<img alt="remove" src={trashIcon} />}
            onClick={() => widgets.remove(id)}
            title="Remove Widget"
            type="text"
          />
        </Flex>
      ),
      title: "Action",
    },
  ]

  return (
    <DefaultPageLayout
      button={
        <CreateButton
          icon={<PlusCircleOutlined />}
          text="Create"
          to={paths.widgetModify}
        />
      }
      emptyBlock={
        <NoContent
          paragraph={
            <Paragraph>
              Cryptix crypto on-ramp widget lets your customers buy <br />
              cryptocurrencies in 5 minutes with their bank card.
            </Paragraph>
          }
          title="No Widgets Yet"
        />
      }
      isEmpty={widgets.isEmpty}
      isLoading={widgets.isLoading && widgets.isEmpty}
      title="On-ramp widget"
    >
      <Table
        columns={columns}
        dataSource={widgets.items}
        loading={widgets.isLoading}
        pagination={widgets.pagination}
      />
    </DefaultPageLayout>
  )
})
